/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from './ApiClient';
import AcademicProgramDocumentType from './model/AcademicProgramDocumentType';
import AcademicSection from './model/AcademicSection';
import AddressType from './model/AddressType';
import City from './model/City';
import ConvocationResignation from './model/ConvocationResignation';
import ConvocationResignationAcademicProgram from './model/ConvocationResignationAcademicProgram';
import ConvocationResignationEligibleAcademicProgram from './model/ConvocationResignationEligibleAcademicProgram';
import ConvocationResignationEligibleFormativeAction from './model/ConvocationResignationEligibleFormativeAction';
import ConvocationResignationProcess from './model/ConvocationResignationProcess';
import ConvocationResignationStudent from './model/ConvocationResignationStudent';
import Country from './model/Country';
import CourseAccessType from './model/CourseAccessType';
import Doc from './model/Doc';
import Document from './model/Document';
import DocumentErrors from './model/DocumentErrors';
import DocumentStatus from './model/DocumentStatus';
import DocumentType from './model/DocumentType';
import DocumentTypeTranslation from './model/DocumentTypeTranslation';
import Error from './model/Error';
import Fixture from './model/Fixture';
import GenderType from './model/GenderType';
import InlineObject from './model/InlineObject';
import InlineObject1 from './model/InlineObject1';
import InlineObject10 from './model/InlineObject10';
import InlineObject11 from './model/InlineObject11';
import InlineObject2 from './model/InlineObject2';
import InlineObject3 from './model/InlineObject3';
import InlineObject4 from './model/InlineObject4';
import InlineObject5 from './model/InlineObject5';
import InlineObject6 from './model/InlineObject6';
import InlineObject7 from './model/InlineObject7';
import InlineObject8 from './model/InlineObject8';
import InlineObject9 from './model/InlineObject9';
import InlineResponse200 from './model/InlineResponse200';
import InlineResponse2001 from './model/InlineResponse2001';
import InlineResponse20010 from './model/InlineResponse20010';
import InlineResponse20011 from './model/InlineResponse20011';
import InlineResponse20012 from './model/InlineResponse20012';
import InlineResponse20012Attempt from './model/InlineResponse20012Attempt';
import InlineResponse20012Building from './model/InlineResponse20012Building';
import InlineResponse20012Data from './model/InlineResponse20012Data';
import InlineResponse20012EventCalendars from './model/InlineResponse20012EventCalendars';
import InlineResponse20012Events from './model/InlineResponse20012Events';
import InlineResponse20012FormativeAction from './model/InlineResponse20012FormativeAction';
import InlineResponse20012StartDateJoin from './model/InlineResponse20012StartDateJoin';
import InlineResponse20013 from './model/InlineResponse20013';
import InlineResponse20013Data from './model/InlineResponse20013Data';
import InlineResponse20013DataStudentSignedPermission from './model/InlineResponse20013DataStudentSignedPermission';
import InlineResponse20014 from './model/InlineResponse20014';
import InlineResponse20014Data from './model/InlineResponse20014Data';
import InlineResponse20015 from './model/InlineResponse20015';
import InlineResponse20015Data from './model/InlineResponse20015Data';
import InlineResponse20016 from './model/InlineResponse20016';
import InlineResponse2002 from './model/InlineResponse2002';
import InlineResponse2003 from './model/InlineResponse2003';
import InlineResponse2004 from './model/InlineResponse2004';
import InlineResponse2005 from './model/InlineResponse2005';
import InlineResponse2006 from './model/InlineResponse2006';
import InlineResponse2007 from './model/InlineResponse2007';
import InlineResponse2008 from './model/InlineResponse2008';
import InlineResponse2009 from './model/InlineResponse2009';
import InlineResponse2009Data from './model/InlineResponse2009Data';
import InlineResponse2009DataDocuments from './model/InlineResponse2009DataDocuments';
import InlineResponse404 from './model/InlineResponse404';
import LastCourseType from './model/LastCourseType';
import Message from './model/Message';
import MessageStatus from './model/MessageStatus';
import MessageType from './model/MessageType';
import Nee from './model/Nee';
import NeeDocuments from './model/NeeDocuments';
import NeeDocumentsData from './model/NeeDocumentsData';
import NeeDocumentsDataDocuments from './model/NeeDocumentsDataDocuments';
import NeeDocumentsStatus from './model/NeeDocumentsStatus';
import NotificationsStatus from './model/NotificationsStatus';
import PresentAddressSelected from './model/PresentAddressSelected';
import PrestaAddress from './model/PrestaAddress';
import ProfileSetChannels from './model/ProfileSetChannels';
import ProfileSetItem from './model/ProfileSetItem';
import ProfileSetItemStatus from './model/ProfileSetItemStatus';
import ProfileSetTypes from './model/ProfileSetTypes';
import ProfileValue from './model/ProfileValue';
import Province from './model/Province';
import Shop from './model/Shop';
import State from './model/State';
import Student from './model/Student';
import StudentAddress from './model/StudentAddress';
import StudentCertifiedCourseAccessDocument from './model/StudentCertifiedCourseAccessDocument';
import StudentCourseAccess from './model/StudentCourseAccess';
import StudentData from './model/StudentData';
import StudentDataSurveyAnswers from './model/StudentDataSurveyAnswers';
import StudentIdentityDocument from './model/StudentIdentityDocument';
import StudentLastCourse from './model/StudentLastCourse';
import StudentMeta from './model/StudentMeta';
import StudentMetaAvailableCAT2122 from './model/StudentMetaAvailableCAT2122';
import StudentMetaAvailableCAT2122Data from './model/StudentMetaAvailableCAT2122Data';
import StudentMetaCoursingEnrolls from './model/StudentMetaCoursingEnrolls';
import StudentMetaEnrolledAcademicPrograms from './model/StudentMetaEnrolledAcademicPrograms';
import StudentMetaFctContracts from './model/StudentMetaFctContracts';
import StudentMetaFctPrecontracts from './model/StudentMetaFctPrecontracts';
import StudentMetaFinishedAcademicPrograms from './model/StudentMetaFinishedAcademicPrograms';
import StudentMetaFormativeActions from './model/StudentMetaFormativeActions';
import StudentMetaTeachingLoad from './model/StudentMetaTeachingLoad';
import StudentPersonalData from './model/StudentPersonalData';
import StudentSurveyAnswer from './model/StudentSurveyAnswer';
import Survey from './model/Survey';
import SurveyAnswer from './model/SurveyAnswer';
import SurveyQuestion from './model/SurveyQuestion';
import ViaType from './model/ViaType';
import AcademicSectionApi from './api/AcademicSectionApi';
import AccountSecretaryStudentDocumentsApi from './api/AccountSecretaryStudentDocumentsApi';
import AceDocumentsApi from './api/AceDocumentsApi';
import AddressApi from './api/AddressApi';
import CertificatesApi from './api/CertificatesApi';
import ConvocationResignationsApi from './api/ConvocationResignationsApi';
import FixtureApi from './api/FixtureApi';
import NeeDocumentsApi from './api/NeeDocumentsApi';
import ProfileSetApi from './api/ProfileSetApi';
import PueCertificatesApi from './api/PueCertificatesApi';
import StudentApi from './api/StudentApi';
import StudentAcademicProgramsTitleApi from './api/StudentAcademicProgramsTitleApi';
import TeachingLoadApi from './api/TeachingLoadApi';


/**
* Student_Account_Api___Validation_flow.<br>
* The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
* <p>
* An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
* <pre>
* var StudentAccount = require('index'); // See note below*.
* var xxxSvc = new StudentAccount.XxxApi(); // Allocate the API class we're going to use.
* var yyyModel = new StudentAccount.Yyy(); // Construct a model instance.
* yyyModel.someProperty = 'someValue';
* ...
* var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
* ...
* </pre>
* <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
* and put the application logic within the callback function.</em>
* </p>
* <p>
* A non-AMD browser application (discouraged) might do something like this:
* <pre>
* var xxxSvc = new StudentAccount.XxxApi(); // Allocate the API class we're going to use.
* var yyy = new StudentAccount.Yyy(); // Construct a model instance.
* yyyModel.someProperty = 'someValue';
* ...
* var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
* ...
* </pre>
* </p>
* @module index
* @version 1.0.0
*/
export {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient,

    /**
     * The AcademicProgramDocumentType model constructor.
     * @property {module:model/AcademicProgramDocumentType}
     */
    AcademicProgramDocumentType,

    /**
     * The AcademicSection model constructor.
     * @property {module:model/AcademicSection}
     */
    AcademicSection,

    /**
     * The AddressType model constructor.
     * @property {module:model/AddressType}
     */
    AddressType,

    /**
     * The City model constructor.
     * @property {module:model/City}
     */
    City,

    /**
     * The ConvocationResignation model constructor.
     * @property {module:model/ConvocationResignation}
     */
    ConvocationResignation,

    /**
     * The ConvocationResignationAcademicProgram model constructor.
     * @property {module:model/ConvocationResignationAcademicProgram}
     */
    ConvocationResignationAcademicProgram,

    /**
     * The ConvocationResignationEligibleAcademicProgram model constructor.
     * @property {module:model/ConvocationResignationEligibleAcademicProgram}
     */
    ConvocationResignationEligibleAcademicProgram,

    /**
     * The ConvocationResignationEligibleFormativeAction model constructor.
     * @property {module:model/ConvocationResignationEligibleFormativeAction}
     */
    ConvocationResignationEligibleFormativeAction,

    /**
     * The ConvocationResignationProcess model constructor.
     * @property {module:model/ConvocationResignationProcess}
     */
    ConvocationResignationProcess,

    /**
     * The ConvocationResignationStudent model constructor.
     * @property {module:model/ConvocationResignationStudent}
     */
    ConvocationResignationStudent,

    /**
     * The Country model constructor.
     * @property {module:model/Country}
     */
    Country,

    /**
     * The CourseAccessType model constructor.
     * @property {module:model/CourseAccessType}
     */
    CourseAccessType,

    /**
     * The Doc model constructor.
     * @property {module:model/Doc}
     */
    Doc,

    /**
     * The Document model constructor.
     * @property {module:model/Document}
     */
    Document,

    /**
     * The DocumentErrors model constructor.
     * @property {module:model/DocumentErrors}
     */
    DocumentErrors,

    /**
     * The DocumentStatus model constructor.
     * @property {module:model/DocumentStatus}
     */
    DocumentStatus,

    /**
     * The DocumentType model constructor.
     * @property {module:model/DocumentType}
     */
    DocumentType,

    /**
     * The DocumentTypeTranslation model constructor.
     * @property {module:model/DocumentTypeTranslation}
     */
    DocumentTypeTranslation,

    /**
     * The Error model constructor.
     * @property {module:model/Error}
     */
    Error,

    /**
     * The Fixture model constructor.
     * @property {module:model/Fixture}
     */
    Fixture,

    /**
     * The GenderType model constructor.
     * @property {module:model/GenderType}
     */
    GenderType,

    /**
     * The InlineObject model constructor.
     * @property {module:model/InlineObject}
     */
    InlineObject,

    /**
     * The InlineObject1 model constructor.
     * @property {module:model/InlineObject1}
     */
    InlineObject1,

    /**
     * The InlineObject10 model constructor.
     * @property {module:model/InlineObject10}
     */
    InlineObject10,

    /**
     * The InlineObject11 model constructor.
     * @property {module:model/InlineObject11}
     */
    InlineObject11,

    /**
     * The InlineObject2 model constructor.
     * @property {module:model/InlineObject2}
     */
    InlineObject2,

    /**
     * The InlineObject3 model constructor.
     * @property {module:model/InlineObject3}
     */
    InlineObject3,

    /**
     * The InlineObject4 model constructor.
     * @property {module:model/InlineObject4}
     */
    InlineObject4,

    /**
     * The InlineObject5 model constructor.
     * @property {module:model/InlineObject5}
     */
    InlineObject5,

    /**
     * The InlineObject6 model constructor.
     * @property {module:model/InlineObject6}
     */
    InlineObject6,

    /**
     * The InlineObject7 model constructor.
     * @property {module:model/InlineObject7}
     */
    InlineObject7,

    /**
     * The InlineObject8 model constructor.
     * @property {module:model/InlineObject8}
     */
    InlineObject8,

    /**
     * The InlineObject9 model constructor.
     * @property {module:model/InlineObject9}
     */
    InlineObject9,

    /**
     * The InlineResponse200 model constructor.
     * @property {module:model/InlineResponse200}
     */
    InlineResponse200,

    /**
     * The InlineResponse2001 model constructor.
     * @property {module:model/InlineResponse2001}
     */
    InlineResponse2001,

    /**
     * The InlineResponse20010 model constructor.
     * @property {module:model/InlineResponse20010}
     */
    InlineResponse20010,

    /**
     * The InlineResponse20011 model constructor.
     * @property {module:model/InlineResponse20011}
     */
    InlineResponse20011,

    /**
     * The InlineResponse20012 model constructor.
     * @property {module:model/InlineResponse20012}
     */
    InlineResponse20012,

    /**
     * The InlineResponse20012Attempt model constructor.
     * @property {module:model/InlineResponse20012Attempt}
     */
    InlineResponse20012Attempt,

    /**
     * The InlineResponse20012Building model constructor.
     * @property {module:model/InlineResponse20012Building}
     */
    InlineResponse20012Building,

    /**
     * The InlineResponse20012Data model constructor.
     * @property {module:model/InlineResponse20012Data}
     */
    InlineResponse20012Data,

    /**
     * The InlineResponse20012EventCalendars model constructor.
     * @property {module:model/InlineResponse20012EventCalendars}
     */
    InlineResponse20012EventCalendars,

    /**
     * The InlineResponse20012Events model constructor.
     * @property {module:model/InlineResponse20012Events}
     */
    InlineResponse20012Events,

    /**
     * The InlineResponse20012FormativeAction model constructor.
     * @property {module:model/InlineResponse20012FormativeAction}
     */
    InlineResponse20012FormativeAction,

    /**
     * The InlineResponse20012StartDateJoin model constructor.
     * @property {module:model/InlineResponse20012StartDateJoin}
     */
    InlineResponse20012StartDateJoin,

    /**
     * The InlineResponse20013 model constructor.
     * @property {module:model/InlineResponse20013}
     */
    InlineResponse20013,

    /**
     * The InlineResponse20013Data model constructor.
     * @property {module:model/InlineResponse20013Data}
     */
    InlineResponse20013Data,

    /**
     * The InlineResponse20013DataStudentSignedPermission model constructor.
     * @property {module:model/InlineResponse20013DataStudentSignedPermission}
     */
    InlineResponse20013DataStudentSignedPermission,

    /**
     * The InlineResponse20014 model constructor.
     * @property {module:model/InlineResponse20014}
     */
    InlineResponse20014,

    /**
     * The InlineResponse20014Data model constructor.
     * @property {module:model/InlineResponse20014Data}
     */
    InlineResponse20014Data,

    /**
     * The InlineResponse20015 model constructor.
     * @property {module:model/InlineResponse20015}
     */
    InlineResponse20015,

    /**
     * The InlineResponse20015Data model constructor.
     * @property {module:model/InlineResponse20015Data}
     */
    InlineResponse20015Data,

    /**
     * The InlineResponse20016 model constructor.
     * @property {module:model/InlineResponse20016}
     */
    InlineResponse20016,

    /**
     * The InlineResponse2002 model constructor.
     * @property {module:model/InlineResponse2002}
     */
    InlineResponse2002,

    /**
     * The InlineResponse2003 model constructor.
     * @property {module:model/InlineResponse2003}
     */
    InlineResponse2003,

    /**
     * The InlineResponse2004 model constructor.
     * @property {module:model/InlineResponse2004}
     */
    InlineResponse2004,

    /**
     * The InlineResponse2005 model constructor.
     * @property {module:model/InlineResponse2005}
     */
    InlineResponse2005,

    /**
     * The InlineResponse2006 model constructor.
     * @property {module:model/InlineResponse2006}
     */
    InlineResponse2006,

    /**
     * The InlineResponse2007 model constructor.
     * @property {module:model/InlineResponse2007}
     */
    InlineResponse2007,

    /**
     * The InlineResponse2008 model constructor.
     * @property {module:model/InlineResponse2008}
     */
    InlineResponse2008,

    /**
     * The InlineResponse2009 model constructor.
     * @property {module:model/InlineResponse2009}
     */
    InlineResponse2009,

    /**
     * The InlineResponse2009Data model constructor.
     * @property {module:model/InlineResponse2009Data}
     */
    InlineResponse2009Data,

    /**
     * The InlineResponse2009DataDocuments model constructor.
     * @property {module:model/InlineResponse2009DataDocuments}
     */
    InlineResponse2009DataDocuments,

    /**
     * The InlineResponse404 model constructor.
     * @property {module:model/InlineResponse404}
     */
    InlineResponse404,

    /**
     * The LastCourseType model constructor.
     * @property {module:model/LastCourseType}
     */
    LastCourseType,

    /**
     * The Message model constructor.
     * @property {module:model/Message}
     */
    Message,

    /**
     * The MessageStatus model constructor.
     * @property {module:model/MessageStatus}
     */
    MessageStatus,

    /**
     * The MessageType model constructor.
     * @property {module:model/MessageType}
     */
    MessageType,

    /**
     * The Nee model constructor.
     * @property {module:model/Nee}
     */
    Nee,

    /**
     * The NeeDocuments model constructor.
     * @property {module:model/NeeDocuments}
     */
    NeeDocuments,

    /**
     * The NeeDocumentsData model constructor.
     * @property {module:model/NeeDocumentsData}
     */
    NeeDocumentsData,

    /**
     * The NeeDocumentsDataDocuments model constructor.
     * @property {module:model/NeeDocumentsDataDocuments}
     */
    NeeDocumentsDataDocuments,

    /**
     * The NeeDocumentsStatus model constructor.
     * @property {module:model/NeeDocumentsStatus}
     */
    NeeDocumentsStatus,

    /**
     * The NotificationsStatus model constructor.
     * @property {module:model/NotificationsStatus}
     */
    NotificationsStatus,

    /**
     * The PresentAddressSelected model constructor.
     * @property {module:model/PresentAddressSelected}
     */
    PresentAddressSelected,

    /**
     * The PrestaAddress model constructor.
     * @property {module:model/PrestaAddress}
     */
    PrestaAddress,

    /**
     * The ProfileSetChannels model constructor.
     * @property {module:model/ProfileSetChannels}
     */
    ProfileSetChannels,

    /**
     * The ProfileSetItem model constructor.
     * @property {module:model/ProfileSetItem}
     */
    ProfileSetItem,

    /**
     * The ProfileSetItemStatus model constructor.
     * @property {module:model/ProfileSetItemStatus}
     */
    ProfileSetItemStatus,

    /**
     * The ProfileSetTypes model constructor.
     * @property {module:model/ProfileSetTypes}
     */
    ProfileSetTypes,

    /**
     * The ProfileValue model constructor.
     * @property {module:model/ProfileValue}
     */
    ProfileValue,

    /**
     * The Province model constructor.
     * @property {module:model/Province}
     */
    Province,

    /**
     * The Shop model constructor.
     * @property {module:model/Shop}
     */
    Shop,

    /**
     * The State model constructor.
     * @property {module:model/State}
     */
    State,

    /**
     * The Student model constructor.
     * @property {module:model/Student}
     */
    Student,

    /**
     * The StudentAddress model constructor.
     * @property {module:model/StudentAddress}
     */
    StudentAddress,

    /**
     * The StudentCertifiedCourseAccessDocument model constructor.
     * @property {module:model/StudentCertifiedCourseAccessDocument}
     */
    StudentCertifiedCourseAccessDocument,

    /**
     * The StudentCourseAccess model constructor.
     * @property {module:model/StudentCourseAccess}
     */
    StudentCourseAccess,

    /**
     * The StudentData model constructor.
     * @property {module:model/StudentData}
     */
    StudentData,

    /**
     * The StudentDataSurveyAnswers model constructor.
     * @property {module:model/StudentDataSurveyAnswers}
     */
    StudentDataSurveyAnswers,

    /**
     * The StudentIdentityDocument model constructor.
     * @property {module:model/StudentIdentityDocument}
     */
    StudentIdentityDocument,

    /**
     * The StudentLastCourse model constructor.
     * @property {module:model/StudentLastCourse}
     */
    StudentLastCourse,

    /**
     * The StudentMeta model constructor.
     * @property {module:model/StudentMeta}
     */
    StudentMeta,

    /**
     * The StudentMetaAvailableCAT2122 model constructor.
     * @property {module:model/StudentMetaAvailableCAT2122}
     */
    StudentMetaAvailableCAT2122,

    /**
     * The StudentMetaAvailableCAT2122Data model constructor.
     * @property {module:model/StudentMetaAvailableCAT2122Data}
     */
    StudentMetaAvailableCAT2122Data,

    /**
     * The StudentMetaCoursingEnrolls model constructor.
     * @property {module:model/StudentMetaCoursingEnrolls}
     */
    StudentMetaCoursingEnrolls,

    /**
     * The StudentMetaEnrolledAcademicPrograms model constructor.
     * @property {module:model/StudentMetaEnrolledAcademicPrograms}
     */
    StudentMetaEnrolledAcademicPrograms,

    /**
     * The StudentMetaFctContracts model constructor.
     * @property {module:model/StudentMetaFctContracts}
     */
    StudentMetaFctContracts,

    /**
     * The StudentMetaFctPrecontracts model constructor.
     * @property {module:model/StudentMetaFctPrecontracts}
     */
    StudentMetaFctPrecontracts,

    /**
     * The StudentMetaFinishedAcademicPrograms model constructor.
     * @property {module:model/StudentMetaFinishedAcademicPrograms}
     */
    StudentMetaFinishedAcademicPrograms,

    /**
     * The StudentMetaFormativeActions model constructor.
     * @property {module:model/StudentMetaFormativeActions}
     */
    StudentMetaFormativeActions,

    /**
     * The StudentMetaTeachingLoad model constructor.
     * @property {module:model/StudentMetaTeachingLoad}
     */
    StudentMetaTeachingLoad,

    /**
     * The StudentPersonalData model constructor.
     * @property {module:model/StudentPersonalData}
     */
    StudentPersonalData,

    /**
     * The StudentSurveyAnswer model constructor.
     * @property {module:model/StudentSurveyAnswer}
     */
    StudentSurveyAnswer,

    /**
     * The Survey model constructor.
     * @property {module:model/Survey}
     */
    Survey,

    /**
     * The SurveyAnswer model constructor.
     * @property {module:model/SurveyAnswer}
     */
    SurveyAnswer,

    /**
     * The SurveyQuestion model constructor.
     * @property {module:model/SurveyQuestion}
     */
    SurveyQuestion,

    /**
     * The ViaType model constructor.
     * @property {module:model/ViaType}
     */
    ViaType,

    /**
    * The AcademicSectionApi service constructor.
    * @property {module:api/AcademicSectionApi}
    */
    AcademicSectionApi,

    /**
    * The AccountSecretaryStudentDocumentsApi service constructor.
    * @property {module:api/AccountSecretaryStudentDocumentsApi}
    */
    AccountSecretaryStudentDocumentsApi,

    /**
    * The AceDocumentsApi service constructor.
    * @property {module:api/AceDocumentsApi}
    */
    AceDocumentsApi,

    /**
    * The AddressApi service constructor.
    * @property {module:api/AddressApi}
    */
    AddressApi,

    /**
    * The CertificatesApi service constructor.
    * @property {module:api/CertificatesApi}
    */
    CertificatesApi,

    /**
    * The ConvocationResignationsApi service constructor.
    * @property {module:api/ConvocationResignationsApi}
    */
    ConvocationResignationsApi,

    /**
    * The FixtureApi service constructor.
    * @property {module:api/FixtureApi}
    */
    FixtureApi,

    /**
    * The NeeDocumentsApi service constructor.
    * @property {module:api/NeeDocumentsApi}
    */
    NeeDocumentsApi,

    /**
    * The ProfileSetApi service constructor.
    * @property {module:api/ProfileSetApi}
    */
    ProfileSetApi,

    /**
    * The PueCertificatesApi service constructor.
    * @property {module:api/PueCertificatesApi}
    */
    PueCertificatesApi,

    /**
    * The StudentApi service constructor.
    * @property {module:api/StudentApi}
    */
    StudentApi,

    /**
    * The StudentAcademicProgramsTitleApi service constructor.
    * @property {module:api/StudentAcademicProgramsTitleApi}
    */
    StudentAcademicProgramsTitleApi,

    /**
    * The TeachingLoadApi service constructor.
    * @property {module:api/TeachingLoadApi}
    */
    TeachingLoadApi
};
